import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "./InputFieldState";

interface TextInputProps {
    label: string;
    state: InputFieldState
    onChange?: (value: string, event: ChangeEvent<HTMLInputElement>) => void;
    errorMessage?: string,
    editable?: boolean,
    darkMode?: boolean,
    type?: string,
    unit?: string,
}

/**
 * Text Input Element
 */
export class TextInput extends React.Component<TextInputProps> {

    public static defaultProps = {
        label: "Label",
        darkMode: false,
        type: "text",
    };

    type: any = this.props.type;

    render() {

        let classNameLabel = this.props.darkMode ? 'label dark-mode-label' : 'label';
        let classNameInput = 'react-input';

        if (this.props.unit) {
            classNameInput += ' with-unit';
        }

        return <label className={classNameLabel}>
            <div className="labelText">{this.props.label}</div>
            <input readOnly={this.props.editable === false} autoComplete="none" onChange={(event) => {
                this.props.onChange(event.target.value, event);
            }} value={this.props.state.value} type={this.type} className={classNameInput}/>
            {this.props.unit &&
                <div className={"input-unit"}>{this.props.unit}</div>
            }
            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }
}